export const msjAlert = {
    data () {
        return {
            alertVisible: false,
            alertMsj: '',
            alertVariant: 'danger',
            // alertCountDown: 10,
            alertCountDown: 5000,
            dismissCountDown: 0,
            alertAction: null,
        }
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
            
            if (this.dismissCountDown == 0) {
                this.alertVisible = false;

                if (this.alertAction) {
                    this.alertAction();
                }
            }      
        },
        showAlert(alertMsj, alertVariant, alertAction) {
            this.alertVisible = true;
            this.alertMsj = alertMsj;
            this.alertVariant = alertVariant;
            this.alertAction = alertAction;
            this.dismissCountDown = this.alertCountDown;    
        },    
        showAlertError(error) {
            let mensaje = 'Error';
            
            /* Verificamos si el parametro es un objeto (Error) o un string */
            if (error) {
                if (typeof(error) === 'object') {
                    if (error.hasOwnProperty('message')) {
                        mensaje = error.message;
                    } else if (error.hasOwnProperty('Message')) {
                        mensaje = error.Message;
                    }

                    if (mensaje.trim() == "ModelStateInvalid") {
                        if (error.Data) {
                            if (error.Data.validations) {
                                mensaje = '';
                                for (const validationItem in error.Data.validations) {
                                    let validation = error.Data.validations[validationItem];
                                    
                                    // mensaje += '\r\n' + validation.key.trim() + ':';
                                    if (validation.errors) {
                                        validation.errors.forEach(error => {
                                            mensaje += '\r\n' + error.errorMessage.trim();
                                        });
                                    }
                                } 
                            }
                        }
                    }

                } else if (typeof(error) === 'string') {
                    mensaje = error;
                }
            }

            this.alertVisible = true;
            this.alertMsj = mensaje;
            this.alertVariant = 'danger';
            this.alertAction = null;
            this.dismissCountDown = this.alertCountDown;    
        },        
    }
}

